import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import { baseURL } from "../BaseUrl";
import Select from "react-select";
import * as swal from "../Consturl/SwalAlert";
import { useDispatch, useSelector } from "react-redux";
import { loadUserDropdown } from "../../redux/action";
import { FloatingLabel } from "react-bootstrap";
import { optionsLeaveTypes } from "../DropdownsData";
import { SBSaveUpdateBtn } from "../SbButtons/SbAddBtn";
import SbCancelBtn from "../SbButtons/SbCancelBtn";
import { toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

export default function AddLeaves(props) {
  /* HEADER AUTH START */
  const userDetails = JSON.parse(sessionStorage.getItem("usdtls"));
  const travelizeAuth = {
    "Content-Type": "application/json",
    Travelize_Authentication: userDetails,
  };
  /* HEADER AUTH END */
  let dispatch = useDispatch();

  const currentYear = new Date().getFullYear();

  const { userDropdown } = useSelector((state) => state.data);
  const [filterUserId, setFilterUserId] = useState("");
  const [leaveTypeID, setLeaveTypeID] = useState(0);
  const [leaveTypes, setLeaveTypes] = useState([]);
  const [leaveYear, setLeaveYear] = useState(currentYear);
  const [leaveAllowed, setLeaveAllowed] = useState(0);
  const [leaveRemain, setLeaveRemain] = useState(0);
  const [leaveTaken, setLeaveTaken] = useState(null);
  const [enableStatus, setEnableStatus] = useState(1);
  const [fieldReq, setFieldReq] = useState(false);
  const [alertMessage, setAlertMessage] = useState({
    alertType: null,
    message: null,
  });

  useEffect(() => {
    fetchLeaveTypes();
  }, []);

  const fetchLeaveTypes = () => {
    let requestOption = {
      method: "GET",
      mode: "cors",
      headers: travelizeAuth,
    };
    fetch(`${baseURL}/api/Leave/BindLeaveTypes`, requestOption)
      .then((res) => res.json())
      .then((res) => {
        if (res.success) {
          setLeaveTypes(
            res.result.map((data) => {
              return {
                value: data.leaveTypeID,
                label: data.leaveTypeName,
              };
            })
          );
        } else {
          setLeaveTypes([]);
        }
      })
      .catch((error) => {
        console.log("ERROR :", error);
      });
  };

  useEffect(() => {
    dispatch(loadUserDropdown());
  }, []);

  // UPDATE LEAVES START
  const addLeaveBalance = () => {
    if (
      filterUserId !== "" &&
      leaveYear !== null &&
      leaveYear !== "" &&
      leaveTypeID !== 0 &&
      leaveAllowed !== 0 &&
      leaveTaken !== null &&
      leaveTaken !== ""
    ) {
      const leavesData = {
        leaveTypeID: leaveTypeID,
        userID: filterUserId,
        status: enableStatus,
        year: leaveYear,
        allowed: leaveAllowed,
        taken: leaveTaken,
        remain: leaveAllowed - leaveTaken,
      };
      let requestOption = {
        method: "POST",
        mode: "cors",
        headers: travelizeAuth,
        body: JSON.stringify(leavesData),
      };
      fetch(`${baseURL}/api/LeaveBalance/AddLeaveBalance`, requestOption)
        .then((res) => res.json())
        .then((res) => {
          if (res.success) {
            props.handleClose();
            props.fetchLeaveBalanceDetails();
            swal.showAlert("Success", `${res.message}`, "success");
          } else {
            // props.handleClose();
            // swal.showAlert("Fail", `${res.errorMessage}`, "warning");
            toast.error(res.errorMessage);
          }
        })
        .catch((error) => {
          // console.log("ERROR :", error);
          toast.error(`${error}`);
        });
    } else {
      setFieldReq(true);
      setAlertMessage({
        alertType: "fail",
        message: "Required",
      });
    }
  };
  // UPDATE LEAVES END

  return (
    <div>
      <Modal
        show={props.leaveBalance}
        // onHide={props.handleClose}
        className="main_model"
      >
        <div className="update-leavestatus-heading">
          <h6 className="page-header-text">ADD LEAVES</h6>
          <i className="fa fa-times" onClick={props.handleClose} />
        </div>
        <div className="container model-update-leavestatus-body">
          <form>
            <div className="update-leave-status">
              <div className="select-status mb-2">
                <div className="mt-3">
                  <FloatingLabel
                    label="Select User"
                    className={`${filterUserId
                        ? "float-visible-select"
                        : "float-hidden float-select"
                      }`}
                  >
                    <Select
                      className="react-select-container-list model-select"
                      classNamePrefix="react-select-list"
                      defaultValue={userDropdown[null]}
                      options={userDropdown}
                      placeholder="Select User"
                      value={userDropdown.value}
                      onInputChange={userDropdown.label}
                      onChange={(data) => setFilterUserId(data.value)}
                      isSearchable={true}
                      required
                    />
                  </FloatingLabel>
                  {fieldReq && filterUserId == "" ? (
                    <small
                      id={`Error${alertMessage.alertType}`}
                      className="form-text text-muted "
                    >
                      {`${alertMessage.message}`}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mt-3">
                  <FloatingLabel
                    label="Year"
                    className={`${leaveYear
                        ? "float-input-visible"
                        : "float-hidden float-input"
                      }`}
                  >
                    <input
                      type="number"
                      className="form-control form add-meetpurpose-input"
                      id="exampleFormControlInput1"
                      placeholder="Year"
                      value={leaveYear}
                      onChange={(e) => setLeaveYear(+e.target.value)}
                      required
                    />
                  </FloatingLabel>
                  {fieldReq && leaveYear == "" ? (
                    <small
                      id={`Error${alertMessage.alertType}`}
                      className="form-text text-muted "
                    >
                      {`${alertMessage.message}`}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mt-3">
                  <FloatingLabel
                    label="Leave Type"
                    className={`${filterUserId
                        ? "float-visible-select"
                        : "float-hidden float-select"
                      }`}
                  >
                    <Select
                      className="react-select-container-list model-select"
                      classNamePrefix="react-select-list"
                      options={leaveTypes}
                      placeholder="Leave Type"
                      value={leaveTypes.value}
                      onInputChange={leaveTypes.label}
                      onChange={(data) => setLeaveTypeID(data.value)}
                      isSearchable={true}
                      required
                    />
                  </FloatingLabel>
                  {fieldReq && leaveTypeID == "" ? (
                    <small
                      id={`Error${alertMessage.alertType}`}
                      className="form-text text-muted "
                    >
                      {`${alertMessage.message}`}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mt-3">
                  <FloatingLabel
                    label="Allotted"
                    className={`${leaveAllowed
                        ? "float-input-visible"
                        : "float-hidden float-input"
                      }`}
                  >
                    <input
                      type="number"
                      className="form-control form add-meetpurpose-input"
                      id="exampleFormControlInput1"
                      placeholder="Allotted"
                      //   value={mobilenum}
                      onChange={(e) => setLeaveAllowed(+e.target.value)}
                      required
                    />
                  </FloatingLabel>
                  {fieldReq && leaveAllowed == "" ? (
                    <small
                      id={`Error${alertMessage.alertType}`}
                      className="form-text text-muted "
                    >
                      {`${alertMessage.message}`}
                    </small>
                  ) : (
                    ""
                  )}
                </div>

                <div className="mt-3">
                  <FloatingLabel
                    label="Availed"
                    className={`${leaveTaken
                        ? "float-input-visible"
                        : "float-hidden float-input"
                      }`}
                  >
                    <input
                      type="number"
                      className="form-control form add-meetpurpose-input"
                      id="exampleFormControlInput1"
                      placeholder="Availed"
                      onChange={(e) => setLeaveTaken(+e.target.value)}
                      required
                    />
                  </FloatingLabel>
                  {fieldReq && (leaveTaken === "" || leaveTaken === null) ? (
                    <small
                      id={`Error${alertMessage.alertType}`}
                      className="form-text text-muted "
                    >
                      {`${alertMessage.message}`}
                    </small>
                  ) : (
                    ""
                  )}
                </div>
                <div className="mt-3">
                  <FloatingLabel
                    label="Available"
                    className={`${leaveRemain !== null
                        ? "float-input-visible"
                        : "float-hidden float-input"
                      }`}
                  >
                    <input
                      type="number"
                      className="form-control form add-meetpurpose-input"
                      id="exampleFormControlInput1"
                      placeholder="Available"
                      value={leaveAllowed - leaveTaken}
                      // onChange={(e) => setLeaveRemain(+e.target.value)}
                      required
                    />
                  </FloatingLabel>
                  {/* {fieldReq && leaveRemain == "" ? (
                    <small
                      id={`Error${alertMessage.alertType}`}
                      className="form-text text-muted "
                    >
                      {`${alertMessage.message}`}
                    </small>
                  ) : (
                    ""
                  )} */}
                </div>

                {/* </div> */}
                {/* </div> */}
              </div>
            </div>
          </form>
        </div>
        <div className="btns-save-cancel">
          <SBSaveUpdateBtn onClickEffect={addLeaveBalance} btnName="Save" />
          <SbCancelBtn btnName="Cancel" onClickEffect={props.handleClose} />
        </div>
      </Modal>
    </div>
  );
}
